import { useEffect, useState } from "react";
import { styled } from "@mui/material";
import Box from "@mui/material/Box";

const FadeInBox = styled(Box)(({ delay }) => ({
  opacity: 0, transition: `opacity 1s ease-in-out ${delay}ms`, '&.visible': {
    opacity: 1,
  },
}));

export function FadeIn({ delay = 0, children }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (<FadeInBox className={visible ? 'visible' : ''} delay={delay}>
    {children}
  </FadeInBox>);
}